var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","lg":"5","md":"6"}},[_c('v-card',[_c('v-container',[_c('table-temperature-monitoring')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }